import axios from 'axios';

import { defaultLocale, LocaleType } from '@/shared/lib/i18n';

export const getLocaleFromPath = (): LocaleType => {
  const pathSegments = window.location.pathname.split('/');
  return (pathSegments[1] as LocaleType) || defaultLocale;
};

export const baseURL = `${process.env.NEXT_PUBLIC_PC_DOMAIN}/api`;

export const client = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.request.use(
  (config) => {
    const locale = getLocaleFromPath();

    // 기존 config.params와 합쳐서 locale 추가
    config.params = {
      ...config.params,
      locale,
    };

    return config;
  },
  (error) => Promise.reject(error),
);
